<template>
  <div class="pt-5">
    <v-expansion-panel-content>
      <v-card-text style="padding: 20px;">
        <CreatePostVenta :toSave="toSave" @goTosave="goTosave" :cuentaId="cuentaId" :readOnly="readOnly" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded dark color="#00a7e4" outlined @click="$emit('changeTab', 1)">
          <h4>
            Cancelar
          </h4>
        </v-btn>
        <v-btn rounded dark class="common-botton" @click="toSave = true">
          <h4 style="color: white;">
            Guardar
          </h4>
        </v-btn>
      </v-card-actions>
      <CommonActionModal :dialog="dialogEleccion" title="Actualizar la Campaña Inbound"
        subtitle="¿Deseas actualizar la campaña?" bottonText="Si, actualizalo" @userChoice="postPutCampaniaInbound" />
    </v-expansion-panel-content>
  </div>
</template>

<script>
import CreatePostVenta from "@/components/commonComponents/forms/CreatePostVenta.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import { postCrearCampaniaInbound, updateCampaniaInbound } from "@/services/campañasPostVentaInbound/CampañasPostVentaInbound";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CreatePostVenta,
    CommonActionModal,
  },
  data() {
    return {
      toSave: false,
      dialogEleccion: false,
      form: {},
      cuentaId: this.$route.params.id,
    };
  },
  methods: {
    goTosave(result, form) {
      if (result) this.dialogEleccion = true;
      this.form = form;
      this.toSave = false;
    },
    postPutCampaniaInbound(val) {
      this.dialogEleccion = false;
      if (val) {
        if (!this.cuentaId) this.postCrearCampaniaInbound();
        else this.editCampaniaInboundByID();
      }
    },
    async postCrearCampaniaInbound() {
      const finalform = {
        ...this.form
      };

      try {
        await postCrearCampaniaInbound(finalform);
        this.$toast.success("Campaña creada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la campaña");
        this.dialogEleccion = false;
      }
    },
    async editCampaniaInboundByID() {
      const finalform = {
        ...this.form
      };

      try {
        await updateCampaniaInbound(finalform, this.cuentaId);
        this.$toast.success("Campaña editada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la campaña");
        this.dialogEleccion = false;
      }
    },
  },
};
</script>
